/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
/* eslint-disable object-curly-newline */
/* eslint-disable react/forbid-prop-types */
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import {
  Grid, Typography, Button, CircularProgress, Snackbar,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import examType1Actions, { sendTestWithRetry } from '../../../../../../../redux/actions/examType1Actions';
import config from '../../../../../../../config';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(1),
    position: 'relative',
  },
  mainTitle: {
    marginTop: '1em',
    textAlign: 'center',
  },
  loadingText: {
    marginTop: '1em',
    textAlign: 'center',
    marginBottom: '30px',
  },
  errorText: {
    marginTop: '1em',
    textAlign: 'center',
    marginBottom: '20px',
    color: theme.palette.error.main,
  },
  button: {
    display: 'block',
    margin: '50px auto 50px auto',
    maxWidth: '260px',
    textAlign: 'center',
  },
  retryButton: {
    display: 'block',
    margin: '20px auto',
    maxWidth: '260px',
  },
  image: {
    width: '35%',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

const TestFinished = ({ testId, answers, clearTest, clearAnswers, setFinished }) => {
  const classes = useStyles();
  const [scores, setScores] = useState(null);
  const [sendError, setSendError] = useState(false);
  const [isSending, setIsSending] = useState(false);

  // Récupère les réponses depuis localStorage en priorité (plus à jour que Redux)
  const getAnswers = () => {
    const stored = localStorage.getItem('answers');
    if (stored) {
      try { return JSON.parse(stored); } catch (e) { /* */ }
    }
    return answers;
  };

  const sendFinal = useCallback(async () => {
    setSendError(false);
    setIsSending(true);
    const body = {
      answers: getAnswers(),
      time: 0,
      isFinished: true,
    };
    const result = await sendTestWithRetry(testId, body);
    setIsSending(false);
    if (result.success && result.data && result.data.test) {
      setScores(result.data.test.examScores);
    } else {
      setSendError(true);
    }
  }, [testId]);

  useEffect(() => {
    sendFinal();
  }, []);

  const endExam = () => {
    setFinished(true);
    clearAnswers();
    clearTest(testId);
  };

  if (isSending) {
    return (
      <Grid container direction="column" className={classes.root} justifyContent="center" alignItems="center">
        <Typography className={classes.loadingText} variant="h5">
          Envoi de vos réponses en cours…
        </Typography>
        <CircularProgress />
      </Grid>
    );
  }

  if (sendError) {
    return (
      <Grid container direction="column" className={classes.root} justifyContent="center" alignItems="center">
        <Typography className={classes.errorText} variant="h6">
          Une erreur réseau a empêché l&apos;envoi de vos réponses.
        </Typography>
        <Typography variant="body1" style={{ textAlign: 'center', marginBottom: '10px', fontSize: 17 }}>
          Vos réponses sont bien conservées. Vérifiez votre connexion puis réessayez.
        </Typography>
        <Button
          className={classes.retryButton}
          color="primary"
          variant="contained"
          onClick={sendFinal}
          fullWidth
        >
          Réessayer l&apos;envoi
        </Button>
      </Grid>
    );
  }

  return scores ? (
    <Grid container direction="row" className={classes.root} justifyContent="center">
      <Grid item md={12}>
        <Typography className={classes.mainTitle} variant="h5">
          Vous avez répondu à toutes les questions.
        </Typography>
        <Grid item md={12}>
          <img className={classes.image} alt="placement test illustration" src={`${config.OBJECT_URL}/thumbnail/end-test.svg`} />
        </Grid>
      </Grid>
      <Button
        className={classes.button}
        color="primary"
        variant="contained"
        onClick={() => endExam()}
      >
        Cliquer ici pour envoyer vos résultats
      </Button>
    </Grid>
  ) : (
    <Grid container direction="column" className={classes.root} justifyContent="center" alignItems="center">
      <Typography className={classes.loadingText} variant="h5">
        Chargement en cours
      </Typography>
      <CircularProgress />
    </Grid>
  );
};

TestFinished.propTypes = {
  testId: PropTypes.string.isRequired,
  answers: PropTypes.array.isRequired,
  setFinished: PropTypes.func.isRequired,
  clearAnswers: PropTypes.func.isRequired,
  clearTest: PropTypes.func.isRequired,
};

const actionCreators = {
  clearTest: examType1Actions.clearTest,
  clearAnswers: examType1Actions.clearAnswers,
};

function mapState(state) {
  const { userData } = state.user;
  const { semester, company, _id } = userData;
  return {
    semester, company, _id,
  };
}
export default connect(mapState, actionCreators)(TestFinished);
